import { useContext } from 'react';
import { gameContext } from '../GameProvider';
export function useGame() {
    var game = useContext(gameContext);
    if (!game) {
        throw new Error('Must be called within World');
    }
    return game;
}
//# sourceMappingURL=useGame.js.map